import { gql } from "@apollo/client";

export const GetItemGroups = gql`
  query GetItemGroups(
    $token: String!
    $customerID: ID!
    $after: Cursor
    $first: Int
    $orderBy: AtsItemGroupOrder
    $name: String
  ) {
    GetItemGroups(
      token: $token
      after: $after
      customerID: $customerID
      first: $first
      orderBy: $orderBy
      where: { or: [{ groupNameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          groupName
          slNo
          customerID
          totalQty
          groupAssoicDetails {
            id
            itemDetails {
              desc
              id
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetItemGroupNodeById = gql`
  query GetItemGroupNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsItemGroup {
        groupName
        slNo
        customerID
      }
    }
  }
`;

export const GetItemGroupAssoic = gql`
  query GetItemGroupAssoic($token: String!, $customerID: ID!, $itemGrpID: ID!) {
    GetItemGroupAssoic(
      token: $token
      customerID: $customerID
      itemGrpID: $itemGrpID
    ) {
      id
      slNo
      qtyNeeded
      customerID
      itemGrpID
      itemID
      itemDetails {
        desc
        id
      }
      itemGrpDetails {
        groupName
      }
    }
  }
`;

export const GetItemGroupsForAssign = gql`
  query GetItemGroups(
    $token: String!
    $customerID: ID!
    $after: Cursor
    $first: Int
    $orderBy: AtsItemGroupOrder
    $name: String
  ) {
    GetItemGroups(
      token: $token
      after: $after
      customerID: $customerID
      first: $first
      orderBy: $orderBy
      where: { or: [{ groupNameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          groupName
          totalQty
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetItemGroupAssemblies = gql`
  query GetItemGroupAssemblies(
    $token: String!
    $customerID: ID!
    $after: Cursor
    $first: Int
    $name: String
    $orderBy: AtsItemGroupAssmbldOrder
  ) {
    GetItemGroupAssemblies(
      token: $token
      customerID: $customerID
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ mapNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          mapNo
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetItemGroupAssemblyDetails = gql`
  query GetItemGroupAssemblyDetails(
    $token: String!
    $customerID: ID!
    $itemGrpID: ID!
    $itemGrpAssmbldID: ID!
  ) {
    GetItemGroupAssemblyDetails(
      token: $token
      customerID: $customerID
      itemGrpID: $itemGrpID
      itemGrpAssmbldID: $itemGrpAssmbldID
    ) {
      id
      mapNo
      itemGrpID
      groupName
      totalQty
      AssemblyItem {
        desc
        itemID
        AssemblyItemDetails {
          prodSerialNo
          qrCode
          alias
          itemDetailsID
        }
      }
    }
  }
`;

export const GetAssembltByNodeById = gql`
  query GetAssembltByNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsItemGroupAssmbld {
        mapNo
        AssemblyItem {
          desc
          itemID
          AssemblyItemDetails {
            itemDetailsID
            prodSerialNo
          }
        }
      }
    }
  }
`;
